const shopDetails = {
    "name": "Lorna's Cakes & Bakes",
    "location": "Oyugis",
    "phone": "0700 809 908",
    "facebook": "Lorna's cakes and Bakes",
    "hero": {
        "title": "Celebrate Every Moment with Sweetness",
        "content": "At Lorna's Cakes & Bakes, baking isn't just a skill; it's an art. Each cake is a masterpiece, meticulously designed and baked to perfection. From classic flavors to innovative creations, discover a symphony of tastes that will tantalize your senses and leave you craving for more.",
    }
};

const cakeType = [
    {
        id: 1,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Vanilla cake",
        price: "$10.00",
        description: "Whispers of pure vanilla magic, a symphony of sweetness in every heavenly bite.",
    },
    {
        id: 2,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Silky cocoa dream: layers of deep chocolate richness with a melt-in-mouth allure.",
    },
    {
        id: 3,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Black forest cake",
        price: "$10.00",
        description: "Dark cherry allure: luscious layers of chocolate and fruit, a woodland delight.",
    },
    {
        id: 4,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Silky cocoa dream: layers of deep chocolate richness with a melt-in-mouth allure.",
    },
    {
        id: 5,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Lemon cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 6,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Cream cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 7,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Vanilla cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 8,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 9,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 10,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 11,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 12,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 13,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 14,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 15,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 16,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 17,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
    {
        id: 18,
        image_url: "/delicious-cake.jpg",
        image_alt: "cake",
        type: "Chocolate cake",
        price: "$10.00",
        description: "Zesty lemon delight: a citrus symphony atop a velvety cake. A slice of sunshine!",
    },
];

const comments = [
    {
        id: 1,
        name: "Jane Doe",
        comment: "I love the cakes very much. Cant wait for my next birthday to order another one",
    },
    {
        id: 2,
        name: "John Amos",
        comment: "Superb cakes indeed. I love the taste.",
    },
    {
        id: 3,
        name: "Amani Mwihoko",
        comment: "Awesome cakes. ",
    },
    {
        id: 4,
        name: "Angel Marion",
        comment: "Thank you for blessing our wedding day with your cakes.",
    },
    {
        id: 5,
        name: "John Moses",
        comment: "The best baker in east africa. Thank you so much for your wonderful cakes.",
    },
    {
        id: 6,
        name: "Unknown",
        comment: "Super fast delivery.",
    },
    {
        id: 7,
        name: "Sam Kinuthia",
        comment: "Fantastic job, my daughter enjoyed the wonderful princess barbie cake.",
    },
    {
        id: 8,
        name: "Moses Gataka",
        comment: "Sweet cakes.",
    },
    {
        id: 9,
        name: "Purity Gachanja",
        comment: "My appetite for cakes never stop when I think of your cakes.",
    },
    {
        id: 10,
        name: "Kelvin Ochieng",
        comment: "I love the cakes madam",
    },
    {
        id: 11,
        name: "Amani Mwihoko",
        comment: "Awesome cakes. The taste is always absolutely amazing.",
    },
    {
        id: 12,
        name: "Emmanuel Opoti",
        comment: "I really love the cakes. Awesome job.",
    },
    {
        id: 13,
        name: "Brenda Molly",
        comment: "Sweeet....",
    },
];

const bakingClasses = [
    {
        id: 1,
        title: "Cupcakes MasterClass",
        price: "$50",
        description: "This Masterclass takes you from Level 0 to Level 100 in making Cupcakes."
    },
    {
        id: 2,
        title: "Wedding Cake MasterClass",
        price: "$50",
        description: "This Masterclass takes you from Level 0 to Level 100 in making Wedding cakes."
    },
    {
        id: 3,
        title: "Birthday Cake MasterClass",
        price: "$50",
        description: "This Masterclass takes you from Level 0 to Level 100 in making Birthday Cakes."
    },
    {
        id: 4,
        title: "Bread MasterClass",
        price: "$50",
        description: "This Masterclass takes you from Level 0 to Level 100 in making Bread."
    },
];

export default { shopDetails, cakeType, comments, bakingClasses };